import { useQuery } from '@tanstack/react-query';

type TemplateInstructionResponse = {
  instructions: string | null;
};

export function useTemplateInstruction(templateId: string | undefined) {
  const { data, isLoading, isError, error } = useQuery<TemplateInstructionResponse>({
    queryKey: ['templates', templateId, 'instructions'],
    enabled: !!templateId,
  });

  return {
    savedInstruction: data?.instructions ?? '',
    isLoading,
    isError,
    error,
  };
}
